import ListMenuItem from "@/app/components/menu/listMenuItem";
import { OverlayMenuBaseProps } from "@/app/components/menu/overlayMenuSystem";
import style from "@/app/components/menu/overlayMenuSystem.module.scss";
import PromotionsIcon from "public/next-public/common/icons/promotions-icon.svg";
import WeeklySpecialsIcon from "public/next-public/common/icons/weekly-specials.svg";

export default function DealsMenu({ closeCallback }: OverlayMenuBaseProps) {
  return (
    <div className={style.overlayMenuContainer}>
      <div className={style.menuListItemContainer}>
        <ListMenuItem
          id="weekly-specials-menu-link"
          iconDecorationPrefix={<WeeklySpecialsIcon />}
          linkTo="/weekly-specials"
          customClickCallback={closeCallback}
        >
          Weekly Specials
        </ListMenuItem>
        <ListMenuItem
          id="promotions-menu-link"
          iconDecorationPrefix={<PromotionsIcon />}
          linkTo="/mfr-promotions"
          customClickCallback={closeCallback}
        >
          Promotions
        </ListMenuItem>
      </div>
    </div>
  );
}
